import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/services/http/http-service.service';
import { EmployeePermission, EmployeePermissions } from 'src/app/models/database/relationals/employee-permission.model';
import { Permissions } from 'src/app/models/database/permission';
import { HttpClient } from '@angular/common/http';
import { Id, Ids } from 'src/app/models/database/types/id.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PermissionService extends HttpService {

  constructor(private http: HttpClient) {
    super('permission')
  }

  verify(permissionId: Id): Observable<boolean> {
    if (permissionId) {
      return this.http.get<boolean>(`${this.url}/verify/${permissionId}`)
    }
  }

  getAllPermissions(filter?: any): Observable<Permissions> {
    let url = this.url
    if (filter) {
      url += this.implementQueries(filter)
    }
    return this.http.get<Permissions>(url)
  }

  getPermissions(employeeId: Id, clinicId: Id): Observable<number[]> {
    return this.http.get<number[]>(`${this.url}/employee/${employeeId}/clinic/${clinicId}`)
  }

  getEmployeePermissions(clinicEmployeeId: Id, filter?: any): Observable<Permissions> {
    let url = `${this.url}/employee/${clinicEmployeeId}`
    if (filter) {
      url += this.implementQueries(filter)
    }
    return this.http.get<Permissions>(url)
  }

  registerEmployeePermissions(clinicEmployeeId: Id, permissions: Ids): Observable<void> {
    return this.http.post<void>(`${this.url}/employee/${clinicEmployeeId}`, { permissions })
  }

  deleteEmployeePermission(employeePermissionId: Id): Observable<void> {
    return this.http.delete<void>(`${this.url}/employee/relation/${employeePermissionId}`)
  }
}